import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import ScopedCssBaseline from '../StyleBase/ScopedCssBaseline';
import config, { renderMediaQueries } from './config';
import { viewports } from '../helper';
import GridColumn from './GridColumn';
import GridRow from './GridRow';

const resolvePadding = () => renderMediaQueries(dimension => css(["padding-right:", ";padding-left:", ";"], config.paddingWidth[dimension], config.paddingWidth[dimension]));

const resolveContainerWidth = () => renderMediaQueries(dimension => config.container[dimension] === 'full' ? css(["width:100%;"]) : css(["width:", ";"], config.container[dimension]));

const Root = styled.div.withConfig({
  displayName: "Grid__Root",
  componentId: "sc-147wn0d-0"
})(["margin-right:auto;margin-left:auto;max-width:100%;", " ", " ", ""], ScopedCssBaseline, () => resolvePadding(), _ref => {
  let {
    fluid
  } = _ref;
  return !fluid && resolveContainerWidth();
});

const Grid = props => /*#__PURE__*/React.createElement(Root, props);

Grid.Styles = Root;
Grid.Column = GridColumn;
Grid.Row = GridRow;
Grid.viewports = {
  smallMobile: viewports.smallMobile,
  mobile: viewports.mobile,
  tablet: viewports.tablet,
  desktop: viewports.desktop,
  largeDesktop: viewports.largeDesktop
};
Grid.defaultProps = {
  fluid: false
};
process.env.NODE_ENV !== "production" ? Grid.propTypes = {
  /**
   * Makes container full-width.
   */
  fluid: PropTypes.bool,

  /**
   * Sets children.
   */
  children: PropTypes.node
} : void 0;
export default Grid;